<template>
	<v-navigation-drawer :clipped="$vuetify.breakpoint.lgAndUp" v-model="drawer" fixed app >
		<v-list dense>
			<div class="NavigatorLogo">
				<img src="@/assets/robot.png">
			</div>
			<template v-for="item in getSignedUser.menu">
				<v-layout v-if="item.heading" :key="item.heading" row align-center>
					<v-flex xs6>
						<v-subheader v-if="item.heading">
							{{ item.heading }}
						</v-subheader>
					</v-flex>
					<v-flex xs6 class="text-xs-center">
						<a href="#!" class="body-2 black--text">EDIT</a>
					</v-flex>
				</v-layout>
				<v-list-group v-else-if="item.children" v-model="item.model" :key="item.text" 
				:prepend-icon="item.icon"
				:append-icon="item.model ? 'keyboard_arrow_down' : 'keyboard_arrow_down'"
				>
					<v-list-tile slot="activator">
						<v-list-tile-content>
							<v-list-tile-title>
								<b>{{ item.text }}</b>
							</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
					<v-list-tile v-for="(child, i) in item.children" :key="i" @click="" :to="child.link" class="menuSubtile">
						<v-list-tile-action v-if="child.icon">
							<v-icon>{{ child.icon }}</v-icon>
						</v-list-tile-action>
						<v-list-tile-content>
							<v-list-tile-title>
								{{ child.text }}
							</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
				</v-list-group>
				<v-list-tile v-else :key="item.text" @click="" :to="item.link">
					<v-list-tile-action>
						<v-icon>{{ item.icon }}</v-icon>
					</v-list-tile-action>
					<v-list-tile-content>
						<v-list-tile-title>
							{{ item.text }}
						</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
			</template>
		</v-list>
	</v-navigation-drawer>
</template>


<script>
	export default {
		name: "Navigation",
		props: {
			drawer: Boolean
		}, 
		data: () => ({ 
			items: [
				// {
				// 	icon: 'contacts',
				// 	text: 'Contacts'
				// },
				{
					icon: 'home',
					text: 'Ana Sayfa',
					link: '/'
				},
				// {
				// 	icon: 'assignment_ind',
				// 	text: 'Platform Hesaplar',
				// 	link: '/platform/accounts'
				// },
				{
					icon: 'storage',
					text: 'Server',
					link: '/server',
					model: true,
					children: [
						{
							icon: 'schedule',
							text: 'Cron Jobs',
							link: '/server/crons',
						},
						{
							icon: 'http',
							text: 'Domainler',
							link: '/server/domains',
						},
						{
							icon: 'pause_circle_filled',
							text: 'Hosting Askı',
							link: '/server/suspended',
						},
					]
				},
				{
					icon: 'mail',
					text: 'Mail Yönetimi',
					link: '/email/'
				},
				{
					icon: 'language',
					text: 'Web',
					model: false,
					link: '/web',
					children: [{
						icon: 'group_work',
						text: 'Netmin Subdomainler',
						link: '/web/netmin/subdomains',
					}]
				},
				{
					iconFile: 'http://robotic.ajans360.com/storage/images/defaults/menu/design.png',
					icon: 'language',
					text: 'Design',
					model: false,
					link: '/design',
					children: [{
						iconFile: 'http://robotic.ajans360.com/storage/images/defaults/menu/design_site.png',
						icon: 'language',
						text: 'Site Tasarımları',
						link: '/design/site',
					},{
						iconFile: 'http://robotic.ajans360.com/storage/images/defaults/menu/design_logo.png',
						icon: 'language',
						text: 'Logo Tasarımları',
						link: '/design/logo',
					}]
				},
				{
					icon: 'pets',
					text: 'Social Media',
					model: false,
					link: '/web',
					children: [{
						icon: 'av_timer',
						text: 'Zamanlı Görevler',
						link: '/socialmedia/cron',
					}]
				},
				{
					icon: 'donut_small',
					text: 'Modüller',
					model: false,
					link: '/modules',
					children: [{
						icon: 'call',
						text: 'Sanal Santral',
						link: '/modules/sanalsantral',
					}]
				},
				 
			]
		}),

		watch : {
			drawer(n){
				this.$emit("drawed" , n)
			}
		},
		computed : { 
			getSignedUser(){
				return this.$store.state.signedUser
			}
		}
	}
</script>


<style lang="less">
.v-navigation-drawer{
	.v-list__tile__action{
		min-width: 40px;

	}
	.v-list__group{
		.v-list__group__header{
			[role="listitem"]{
				.v-list__tile{ 
    				padding-left: 0px !important;
				}
			}
		}
	}
	.menuSubtile{
		.v-list__tile__action{
				min-width: 30px;
				margin-left: 30px;
		}
	}
}
.NavigatorLogo{
	text-align:center;
	padding-bottom:15px;
	margin-bottom : 15px;
	border-bottom:1px solid #ccc;
	img {
		height: 100px;
	}
}
</style>
